import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiService } from './adminApi.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiUrl = environment.api;

  constructor(private http: HttpClient, private api: ApiService) { }

  //  Solicitar el OTP al backend
  solicitarOTP(cedula: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/login`, { cedula });
  }

  //  Validar el OTP recibido por el usuario
  validarOTP(cedula: string, otp: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/validate-otp`, { cedula, otp });
  }

  //  Guardar el token de sesión localmente
  guardarTokenSesion(token: string): void {
    localStorage.setItem('tokenSesion', token);
  }
  guardarUsuarioId(usuarioId: any): void {
    localStorage.setItem('usuarioId', usuarioId);
  }

  //  Obtener el token de sesión (si existe)
  obtenerTokenSesion(): string | null {
    return localStorage.getItem('tokenSesion');
  }

  obtenerUsuarioId(): string | null {
    return localStorage.getItem('usuarioId');
  }

  //  Saber si el usuario está autenticado
  estaAutenticado(): boolean {
    return this.obtenerTokenSesion() !== null && this.obtenerUsuarioId() !== null;
  }

  obtenerInformacionusuario(): Observable<any> {
    return this.api.get('usuario', '',
      { 'x-session-token': `${this.obtenerTokenSesion()}` }
    );
  }


  // Cerrar sesión (borrar el token)
  cerrarSesion(): void {
    localStorage.removeItem('tokenSesion');
  }
}
